/**
 * File containing util functions
 */

export const isPositiveValue = (value) => !!value && !isNaN(value) && value > 0

export const sumFloat = (x, y) => {
  let fx = !!x && !isNaN(x) ? x : 0
  let fy = !!y && !isNaN(y) ? y : 0
  return parseFloat(fx + fy).toFixed(2)
}
